export default __webpack_public_path__ + "static/media/son.f9caa390.svg";